
import GeradorForm from "@/components/geradores/GeradorForm";
import Layout from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const GeradorNovo = () => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-energy-green-dark">Novo Gerador</h1>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => navigate("/energia")} 
            className="flex items-center gap-2 bg-green-500/10 hover:bg-green-500/20 text-green-700"
          >
            <ArrowLeft className="h-4 w-4" /> Voltar para Energia
          </Button>
        </div>
        <GeradorForm />
      </div>
    </Layout>
  );
};

export default GeradorNovo;
